import { connect } from 'react-redux';

// Components:
import { getClientEmail } from 'src/store/client/selectors';
import { getErrorMessage } from 'src/store/error/selectors';
import SuccessPopup from '../components/SuccessPopup';

// Selectors:
import {
  getOrderIsPaid,
  getPaymentAmount,
} from '../../../store/payment/selectors';
import { getCertLink } from '../store/certificate/selectors';

// Actions:
import { downloadCertificateAction } from '../store/certificate/sagaActions';

const mapStateToProps = (state) => ({
  isShown: getOrderIsPaid(state),
  amount: getPaymentAmount(state),
  clientEmail: getClientEmail(state),
  errorMessage: getErrorMessage(state),
  link: getCertLink(state),
});

const mapDispatchToProps = {
  handleFetchCertLink: downloadCertificateAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(SuccessPopup);
